// @flow
import mediatorChannels from "@tvg/mediator";
import { get } from "lodash";
import pushToDataLayer from "../gtmUtils";

type TrackGTMTypeEvents =
  | "PPM_NEXT_RACE"
  | "PPM_PREVIOUS_RACE"
  | "PPM_PROMOS"
  | "PPM_GO_BACK"
  | "PPM_RACING_TIP_MORE"
  | "PPM_RUNNER_SELECTION_2"
  | "PPM_TOOLTIP_CLICKED"
  | "PPM_DEPOSIT_NOW_CLICK";

type TrackGTMType = {
  type: TrackGTMTypeEvents,
  payload: {
    add?: boolean,
    tag?: string,
    action?: string,
    selections?: string,
    betAmount?: string,
    runnerType?: string,
    label?: string,
    error?: string,
    trackName?: string,
    raceNumber?: string,
    betType?: string,
    primaryType?: string,
    secondaryType?: string,
    product?: string,
    destinationUrl?: string,
    race?: {
      raceNumber: string,
      track: {
        trackName: string
      },
      type: {
        code: string
      }
    },
    isCustomAmount?: boolean,
    module?: string,
    mtp?: string
  }
};

export default () => {
  mediatorChannels.base.subscribe("PPM_NEXT_RACE", (data: TrackGTMType) => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site Click",
      gaEventAction: "next",
      gaEventLabel: `${get(data, "payload.trackName")} - R${get(
        data,
        "payload.raceNumber"
      )}`,
      module: "race info header",
      tag: undefined,
      microApp: undefined
    });
  });
  mediatorChannels.base.subscribe("PPM_PREVIOUS_RACE", (data: TrackGTMType) => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site Click",
      gaEventAction: "back",
      gaEventLabel: `${get(data, "payload.trackName")} - R${get(
        data,
        "payload.raceNumber"
      )}`,
      module: "race info header",
      tag: undefined,
      microApp: undefined
    });
  });
  mediatorChannels.base.subscribe("PPM_PROMOS", (data: TrackGTMType) => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site Click",
      gaEventAction: "open",
      gaEventLabel: "promos",
      module: "race info header",
      tag: `${get(data, "payload.trackName")} - R${get(
        data,
        "payload.raceNumber"
      )} - ${get(data, "payload.optedIn") ? "Opted-In" : "Opted-Out"}`,
      microApp: undefined
    });
  });
  mediatorChannels.base.subscribe("PPM_OPEN_UPCOMING", (data: TrackGTMType) => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site Click",
      gaEventAction: "open",
      gaEventLabel: "upcoming races",
      module: "race info header",
      tag: `${get(data, "payload.trackName")} - R${get(
        data,
        "payload.raceNumber"
      )}`,
      microApp: undefined
    });
  });
  mediatorChannels.base.subscribe("PPM_GO_BACK", (data: TrackGTMType) => {
    pushToDataLayer({
      event: "navigation",
      gaEventCategory: "navigation",
      gaEventAction: "navigated to",
      gaEventLabel: "back button",
      module: "header",
      tag: undefined,
      microApp: undefined,
      sport: "Horse Racing",
      destinationUrl: get(data, "payload.destinationUrl")
    });
  });
  mediatorChannels.base.subscribe("PPM_WAGER_SCROLL", (data: TrackGTMType) => {
    pushToDataLayer({
      event: "betSelector",
      gaEventCategory: "bet selector",
      gaEventAction: "scrolled bet types",
      gaEventLabel: get(data, "payload.label", ""),
      module: "bet selector"
    });
  });
  mediatorChannels.base.subscribe(
    "PPM_WAGER_TYPE_SELECT",
    (data: TrackGTMType) => {
      pushToDataLayer({
        event: "betSelector",
        gaEventCategory: "bet selector",
        gaEventAction: "selected bet type",
        gaEventLabel: `${get(data, "payload.label")}`,
        module: "bet selector"
      });
    }
  );
  mediatorChannels.base.subscribe(
    "PPM_RACING_TIP_MORE",
    (data: TrackGTMType) => {
      pushToDataLayer({
        event: "siteClick",
        gaEventCategory: "Site Click",
        gaEventAction: "select",
        gaEventLabel: "more",
        module: "racing tips",
        tag: `${get(data, "payload.trackName")} - R${get(
          data,
          "payload.raceNumber"
        )} - ${get(data, "payload.mtp")}`,
        microApp: undefined
      });
    }
  );

  type ResultGtmChangeTrackNextRace = {
    type: "RACE_RESULTS_CHANGE_RACE",
    payload: {
      actionName: "Next Race" | "Change Track",
      destinationUrl: string,
      module: "Result" | "Racecard"
    }
  };

  mediatorChannels.base.subscribe(
    "RACE_RESULTS_CHANGE_RACE",
    (data: ResultGtmChangeTrackNextRace) => {
      pushToDataLayer({
        event: "navigation",
        gaEventCategory: "Navigation",
        gaEventAction: "Navigated to",
        gaEventLabel: data.payload.actionName,
        module: data.payload.module,
        microApp: "non-Microapp",
        destinationUrl: data.payload.destinationUrl
      });
    }
  );

  mediatorChannels.base.subscribe(
    "RUNNER_INFO:EXPAND_COLLAPSE",
    (data: { expandAction: "Expand" | "Collapse", runnerId: string }) => {
      pushToDataLayer({
        event: "siteClick",
        gaEventCategory: "Site Click",
        gaEventAction: get(data, "payload.expandAction"),
        gaEventLabel: "Inline Past Performances",
        module: "Race Card",
        tag: get(data, "payload.runnerId"),
        microApp: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    "TRACK_RACE_SELECTOR",
    (data: { payload: { raceNumberSelected: number } }) => {
      pushToDataLayer({
        event: "raceSelector",
        gaEventCategory: "race selector",
        gaEventAction: "selected race number",
        gaEventLabel: `${get(data, "payload.raceNumberSelected")}`,
        module: "race selector"
      });
    }
  );

  mediatorChannels.base.subscribe(
    "PPM_RUNNER_SELECTION_2",
    (data: TrackGTMType) => {
      pushToDataLayer({
        betAmount: undefined,
        betId: undefined,
        betType: get(data, "payload.betType"),
        event: "bet",
        gaEventAction: get(data, "payload.action"),
        gaEventCategory: "Bet",
        gaEventLabel: get(data, "payload.label"),
        gaEventValue: undefined,
        module: "Race Card",
        raceNumber: get(data, "payload.race.raceNumber"),
        repeatBet: undefined,
        sport:
          get(data, "payload.race.type.code") === "G"
            ? "Greyhounds Racing"
            : "Horse Racing",
        tag: get(data, "payload.tag"),
        trackName: get(data, "payload.race.track.trackName")
      });
    }
  );

  mediatorChannels.base.subscribe("PPM_TOOLTIP_CLICKED", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site Click",
      gaEventAction: "Open",
      gaEventLabel: "Handicapping Tooltip",
      module: "Race Card",
      tag: undefined
    });
  });

  mediatorChannels.base.subscribe(
    "PPM_DEPOSIT_NOW_CLICK",
    (data: { destinationURL: string }) => {
      pushToDataLayer({
        event: "navigation",
        gaEventCategory: "Navigation",
        gaEventAction: "Navigated To",
        gaEventLabel: "Deposit Now",
        module: "Bet Ticket",
        destinationUrl: data.destinationURL,
        tag: undefined
      });
    }
  );
};
